import React from "react";
import { DocumentTitle, PageHeader } from "components/common";
import { Alert, Row, Col } from "components/bootstrap";
import DataLakeBackendButton from "data-lake/data-lake-backend-config/DataLakeBackendButton";
import DataLakePageNavigation from "data-lake/components/DataLakePageNavigation";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import { DATA_LAKE_LICENSE_TITLE, DATA_LAKE_LICENSE_TEXT } from "data-lake/Constants";
import DocsHelper from "util/DocsHelper";
import BackendConfigOverview from "./BackendConfigOverview";
const DataLakeBackendPage = () => /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Data Lake Backend Configurations" }, /* @__PURE__ */ React.createElement(DataLakePageNavigation, null), /* @__PURE__ */ React.createElement(
  PageHeader,
  {
    title: "Data Lake Backend Configurations",
    documentationLink: {
      title: "Data Lake documentation",
      path: DocsHelper.PAGES.DATA_LAKE
    },
    actions: /* @__PURE__ */ React.createElement(DataLakeBackendButton, null)
  },
  /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, "Data Lake may use either an ", /* @__PURE__ */ React.createElement("strong", null, "Amazon S3/Google Cloud Storage Bucket/Azure Blob Storage"), ", or local network storage as a backend.", /* @__PURE__ */ React.createElement("br", null), "Note that only one Data Lake backend may be configured at a time, and when changing backend configuration, existing stored data will not be automatically moved to the new backend and will remain in the old one.", /* @__PURE__ */ React.createElement("br", null), "In this circumstance, data should be migrated between back-ends outside of the product."),
  /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, "When using a filesystem - altering the permissions of files in the Data Lake backend can result in corruption of data.")
), /* @__PURE__ */ React.createElement(
  LicenseCheck,
  {
    licenseSubject: LICENSE_SUBJECTS.archive,
    title: DATA_LAKE_LICENSE_TITLE,
    text: DATA_LAKE_LICENSE_TEXT,
    displayWarningContainer: true,
    bsStyle: "danger"
  }
), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(BackendConfigOverview, null))));
export default DataLakeBackendPage;
